import { IPortalScoreItem } from '../../interfaces/property';

export const setProfileCompleteness = (payload: IPortalScoreItem) : any => {
    return {
        type: 'SET_PROFILE_COMPLETENESS',
        payload
    };
};